import React from 'react';
import Immutable from 'immutable';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  Container,
  SearchFacets, SearchSorting,
} from '@uncinc/uncinc-react-kitchen-sink';

import ExternalPublication from '../../../components/Molecules/ExternalPublication';
import * as query from './query.gql';
import { ChipFacet } from '../../../components/SearchKit/ChipFacet';
import SearchLoadMore from '../../../components/SearchKit/SearchLoadMore';
import { SelectFacet } from '../../../components/SearchKit/SelectFacet';

import './style.scss';
import SearchKitVNL from '../../../components/SearchKit';
import SearchResults from '../../../components/SearchKit/SearchResults';

const SearchItem = ({ item }) => {
  const classes = classNames('ParagraphExternalPublicationsOverview__row');
  const immutableItem = Immutable.fromJS(item.fields);
  const title = immutableItem.getIn(['title', 0]);
  const url = immutableItem.getIn(['field_link', 0]);
  const year = immutableItem.getIn(['field_year', 0]);
  const authors = immutableItem.getIn(['field_naam_auteur', 0], '');

  return (
    <div className={classes}>
      <ExternalPublication
        year={year}
        authors={authors}
        title={title}
        link={url}
      />
    </div>
  );
};

const SearchHeader = () => {
  return (
    <span />
  );
};

const ParagraphExternalPublicationsOverview = () => {
  const { t } = useTranslation();

  return (
    <div className="Paragraph ParagraphExternalPublicationsOverview">
      <Container>
        <SearchKitVNL
          query={query}
          pageSize={24}
          defaultSorting="created"
        >
          {
            (data, loading) => (
              <>
                {data && (
                  <div className="Search__results">
                    <div className="Search__results__filters__wrapper">
                      <div className="Search__results__filters">
                        <div className="Search__results__filters__items">
                          <span>Filter</span>
                          <SearchFacets data={data.externalPublications} loading={loading} facets={[ChipFacet, SelectFacet]} />
                        </div>
                        <div className="Search__results__filters__sorting">
                          <span>{t('general.sort')}</span>
                          <SearchSorting data={data.externalPublications} loading={loading} />
                        </div>
                      </div>
                      <div className="total-count">
                        {data.externalPublications.results.summary.total} {t('general.search_results')}
                      </div>
                    </div>
                    <SearchResults
                      data={data.externalPublications}
                      renderItem={SearchItem}
                      renderHeader={SearchHeader}
                      appendResults
                    />
                    <SearchLoadMore data={data ? data.externalPublications : null} />
                  </div>
                )}
              </>
            )
          }
        </SearchKitVNL>
      </Container>
    </div>
  );
};

export default ParagraphExternalPublicationsOverview;
